import type { MouseEvent } from 'react'

interface ColumnResizeHandleProps {
    onResizeMouseDown: (e: MouseEvent<HTMLSpanElement>) => void
}

/**
 * Drag handle on the right edge of a column header. Stops propagation so sort clicks do not fire.
 */
export default function ColumnResizeHandle({ onResizeMouseDown }: ColumnResizeHandleProps) {
    return (
        <span
            className="column-resize-handle"
            role="separator"
            aria-orientation="vertical"
            aria-hidden
            onMouseDown={onResizeMouseDown}
            onClick={(e) => e.stopPropagation()}
        />
    )
}
